import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { addAvatarText } from '_utils/function';
import { AVATAR_BG_CLASSES } from '../../constant';
import './style.scss';

const getAvatarClass = (name = '') => {
  if (!name) return AVATAR_BG_CLASSES[0];
  const charCodeSum = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return AVATAR_BG_CLASSES[charCodeSum % AVATAR_BG_CLASSES.length];
};

const MemberAvatar = ({
  member = null,
  name = '',
  photoUrl = '',
  className = '',
  style = undefined,
  children = null,
}) => {
  const displayName = name || member?.uName || member?.name || 'Member';
  const avatarUrl = photoUrl || member?.photoUrl;
  const avatarClass = getAvatarClass(displayName);
  const initials = addAvatarText(displayName) || 'M';

  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [avatarUrl]);

  return (
    <div
      className={`member-avatar ${avatarClass} ${className}`.trim()}
      style={style}
    >
      {avatarUrl && !imgError ? (
        <img
          src={avatarUrl}
          alt={displayName}
          onError={() => setImgError(true)}
        />
      ) : (
        <span>{initials}</span>
      )}
      {children}
    </div>
  );
};

MemberAvatar.propTypes = {
  member: PropTypes.shape({
    name: PropTypes.string,
    uName: PropTypes.string,
    photoUrl: PropTypes.string,
  }),
  name: PropTypes.string,
  photoUrl: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default memo(MemberAvatar);
